// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"f9290dca","490":"6e85e493"}[chunkId] + ".chunk.css";
};